class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.endTime = Date.parse(this.dataset.endDate);
    this.wrapper = this.closest('.product__countdown');

    if (isNaN(this.endTime)) {
      if (this.wrapper) this.wrapper.hidden = true;
      return;
    }

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  update() {
    const diff = this.endTime - Date.now();

    if (diff <= 0) {
      clearInterval(this.interval);
      if (this.wrapper) this.wrapper.hidden = true;
      return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    this.setUnit('days', days);
    this.setUnit('hours', hours);
    this.setUnit('minutes', minutes);
    this.setUnit('seconds', seconds);
  }

  setUnit(name, value) {
    const el = this.querySelector(`[data-${name}]`);
    if (el) el.textContent = String(value).padStart(2, '0');
  }
}

customElements.define('countdown-timer', CountdownTimer);
